import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useSubscribedProfiles } from '#network/Billing';
import { isLiquidNobleLoggedIn, getSessionProfileId } from '#modules/utils/jwt';
import { usePersonalProfile } from '@tokenized/sdk-react-private';

export function useSelectedProfileId() {
  const location = useLocation();
  const sessionProfileId = getSessionProfileId();

  const { entity: urlEntity } = queryString.parse(location.search) || {};

  const profiles = useSubscribedProfiles();
  const personalProfile = usePersonalProfile();
  const isLqnLoggedIn = isLiquidNobleLoggedIn();

  if (urlEntity) {
    const entityProfileId = profiles?.find?.(
      ({ entityId }) => entityId === urlEntity,
    )?.id;
    if (entityProfileId) {
      return entityProfileId;
    }
  }

  if (personalProfile) {
    if (
      profiles?.some(({ entityId }) => entityId === personalProfile.entityId)
    ) {
      return personalProfile.id;
    }
  }

  if (profiles?.length) {
    return profiles.find(
      (profile) =>
        profile.isTokenizedEntity !== isLqnLoggedIn &&
        (!isLqnLoggedIn ||
          !sessionProfileId ||
          profile.id === sessionProfileId),
    )?.id;
  }

  if (personalProfile) {
    return personalProfile.id;
  }
}

export function useSelectedEntityId() {
  const location = useLocation();
  const sessionProfileId = getSessionProfileId();

  const { entity: urlEntity } = queryString.parse(location.search) || {};

  const profiles = useSubscribedProfiles();
  const personalProfile = usePersonalProfile();
  const isLqnLoggedIn = isLiquidNobleLoggedIn();

  if (!isLqnLoggedIn) {
    // Always return entityId from the personal profile or the list of profiles matching the personal profile ID
    if (personalProfile) {
      return personalProfile.entityId;
    }
    const matchingProfile = profiles?.find?.(
      (profile) =>
        profile.isTokenizedEntity &&
        profile.entityId === profile.individualEntityId,
    );
    if (matchingProfile) {
      return matchingProfile.entityId;
    }
  }

  if (urlEntity) {
    const entityProfileId = profiles?.find?.(
      ({ entityId }) => entityId === urlEntity,
    )?.id;
    if (entityProfileId) {
      return urlEntity;
    }
  }

  if (personalProfile) {
    if (
      profiles?.some(({ entityId }) => entityId === personalProfile.entityId)
    ) {
      return personalProfile.entityId;
    }
  }

  if (profiles?.length) {
    return profiles.find(
      (profile) =>
        profile.isTokenizedEntity !== isLqnLoggedIn &&
        (!isLqnLoggedIn ||
          !sessionProfileId ||
          profile.id === sessionProfileId),
    )?.entityId;
  }

  if (personalProfile) {
    return personalProfile.entityId;
  }
}

export function locationToSwitchProfile(currentLocation, entityId) {
  const queryParts = queryString.parse(currentLocation?.search) || {};
  return {
    ...currentLocation,
    search: queryString.stringify({
      ...queryParts,
      entity: entityId,
    }),
  };
}
